import React from 'react';
import styled from 'styled-components';
import { InputStyling } from './styles';
import { CompanyInputTag } from '@containers/form/TagInput';
import { TagSearchInput } from '.';
import { filterDuplicateCompanies } from '@utils/usefulFuncs';

const TagInputWrapper = styled.div``;

const useBackspaceToRemoveLastEnteredTag = (inputRef, tags, removeLastEnteredTag) => {
  React.useEffect(() => {
    const handleDeleteTagKeyBinds = (e) => {
      const key = e?.key?.toLowerCase();
      const wasBackspace = key === 'backspace';
      if (!wasBackspace) {
        return;
      }
      if (tags.length === 0) {
        return;
      }
      const textInputHasFocus = inputRef.current === document.activeElement;
      if (!textInputHasFocus) {
        return;
      }
      const textInputValue = inputRef.current?.value;
      if (textInputValue !== '') {
        return;
      }

      removeLastEnteredTag();
    };
    document.addEventListener('keydown', handleDeleteTagKeyBinds);
    return () => {
      document.removeEventListener('keydown', handleDeleteTagKeyBinds);
    };
  }, [inputRef, tags, removeLastEnteredTag]);

  return null;
};

export const TagSelector = ({ tags, onChange, enableCreateTag }) => {
  const inputRef = React.useRef(null);

  const onAddTag = (tag) => {
    onChange(filterDuplicateCompanies([...tags, tag]));
  };

  const handleRemoveTag = (tag) => {
    onChange(tags.filter((t) => t !== tag));
  };

  const removeLastEnteredTag = React.useCallback(() => {
    onChange(tags.filter((t) => t !== tags[tags.length - 1]));
  }, [onChange, tags]);

  useBackspaceToRemoveLastEnteredTag(inputRef, tags, removeLastEnteredTag);

  return (
    <TagInputWrapper>
      <InputStyling>
        {tags?.map((t) => (
          <CompanyInputTag
            key={t.symbol || 'id:' + t.company_id || 'tag' + t.doc_tag_id}
            value={t}
            onRemoveTag={handleRemoveTag}
          />
        ))}
        <TagSearchInput forwardRef={inputRef} onAddTag={onAddTag} enableCreateTag={enableCreateTag} />
      </InputStyling>
    </TagInputWrapper>
  );
};
